import axios from "axios";
import { headers, reqErrorHandler, reqHandler, resErrorHandler, resHandler } from "./common/axiosUtil";

const xeroxLocalApi = axios.create({
    baseURL: "/assets/data", headers
});

xeroxLocalApi.interceptors.request.use(reqHandler, reqErrorHandler);
xeroxLocalApi.interceptors.response.use(resHandler, resErrorHandler);

export default xeroxLocalApi;
